// src/themes/global-foundations.colors.ts
var lightColours = {
  primary: {
    50: "#FF3F3F",
    100: "#4D0000",
    soft: "#FFD9D9",
    medium: "#FF9F9F",
    strong: "#AA2A2A",
    tintSoft: "#FFD9D9",
    tintMedium: "#FF9F9F",
    tintStrong: "#AA2A2A"
  },
  secondary: {
    50: "#606FFF",
    100: "#040154",
    soft: "#CACFFF",
    medium: "#959FFF",
    strong: "#3A3787",
    tintSoft: "#CACFFF",
    tintMedium: "#959FFF",
    tintStrong: "#3A3787"
  },
  neutral: {
    0: "#FFFFFF",
    5: "#F7F7F6",
    10: "#E5E5E5",
    20: "#CCCCCB",
    30: "#B2B2B2",
    40: "#999998",
    50: "#80807F",
    55: "#707070",
    60: "#666666",
    70: "#4D4D4C",
    80: "#333333",
    90: "#292929",
    95: "#1A1A19",
    100: "#0D0D0D"
  },
  accent: {
    5: "#DFE2FF",
    10: "#CACFFF",
    20: "#AFB7FF",
    30: "#959FFF",
    40: "#7B87FF",
    50: "#606FFF",
    60: "#505DD4",
    70: "#404AAA",
    80: "#303880",
    90: "#202555",
    100: "#131633"
  },
  positive: {
    5: "#F9FFFA",
    10: "#DCFFE2",
    20: "#CAFFD3",
    30: "#B8FFC5",
    40: "#A7FFB6",
    50: "#95FFA8",
    60: "#7CD48C",
    70: "#63AA70",
    80: "#4B8054",
    90: "#325538",
    100: "#1E3322"
  },
  caution: {
    5: "#FFEADC",
    10: "#FFDCC5",
    20: "#FFCAA7",
    30: "#FFB98A",
    40: "#FFA76D",
    50: "#FF9650",
    60: "#D47D43",
    70: "#AA6435",
    80: "#804B28",
    90: "#55321B",
    100: "#331E10"
  }
};
var colors = {
  ...lightColours,
  // Utility colors
  neutral: {
    ...lightColours.neutral,
    base: lightColours.neutral[0],
    extraSoft: lightColours.neutral[5],
    soft: lightColours.neutral[10],
    medium: lightColours.neutral[40],
    strong: lightColours.neutral[60],
    // Deprecated colors, kept for backwards compatibility
    100: lightColours.neutral[10],
    200: lightColours.neutral[20],
    300: lightColours.neutral[30],
    400: lightColours.neutral[40],
    500: lightColours.neutral[50],
    600: lightColours.neutral[60],
    700: lightColours.neutral[70],
    800: lightColours.neutral[80],
    900: lightColours.neutral[90]
  },
  accent: {
    ...lightColours.accent,
    extraSoft: lightColours.accent[5],
    soft: lightColours.accent[10],
    medium: lightColours.accent[40],
    strong: lightColours.accent[60]
  },
  positive: {
    ...lightColours.positive,
    extraSoft: lightColours.positive[5],
    soft: lightColours.positive[10],
    medium: lightColours.positive[40],
    strong: lightColours.positive[60]
  },
  caution: {
    ...lightColours.caution,
    extraSoft: lightColours.caution[5],
    soft: lightColours.caution[10],
    medium: lightColours.caution[40],
    strong: lightColours.caution[60]
  },
  // Brand colours
  primary: {
    ...lightColours.primary,
    DEFAULT: lightColours.primary[50],
    fg: lightColours.neutral[0],
    int: lightColours.primary.tintStrong,
    alt: lightColours.primary[100],
    altFg: lightColours.neutral[0],
    altInt: lightColours.primary.tintMedium,
    soft: lightColours.primary.tintSoft,
    medium: lightColours.primary.tintMedium,
    strong: lightColours.primary.tintStrong,
    // Deprecated
    200: "#FBEBEF",
    // mapping to primary.tintSoft #FFD9D9
    700: "#D10A38",
    // mapping to primary[50] #FF3F3F
    800: "#BD0024",
    // mapping to primary.tintStrong #AA2A2A
    50: "#FF3F3F",
    100: "#4D0000"
  },
  secondary: {
    ...lightColours.secondary,
    DEFAULT: lightColours.secondary[100],
    fg: lightColours.neutral[0],
    int: lightColours.secondary.tintStrong,
    alt: lightColours.secondary[50],
    altFg: lightColours.secondary[100],
    altInt: lightColours.secondary.tintSoft,
    soft: lightColours.secondary.tintSoft,
    medium: lightColours.secondary.tintMedium,
    strong: lightColours.secondary.tintStrong
  },
  // Alias colors
  info: {
    soft: lightColours.accent[10],
    medium: lightColours.accent[40],
    strong: lightColours.accent[60]
  },
  success: {
    soft: lightColours.positive[10],
    medium: lightColours.positive[40],
    strong: lightColours.positive[60],
    /**
     * @deprecated use semantic names moving forward
     */
    500: "#36C075"
  },
  error: {
    soft: lightColours.caution[10],
    medium: lightColours.caution[40],
    strong: lightColours.caution[60]
  },
  disabled: {
    soft: lightColours.neutral[5],
    strong: lightColours.neutral[40]
  },
  // Web UI specific colors
  main: {
    DEFAULT: lightColours.neutral[0],
    fg: lightColours.neutral[95]
  },
  card: {
    DEFAULT: lightColours.neutral[0],
    fg: lightColours.neutral[95],
    border: lightColours.neutral[5]
  },
  link: {
    DEFAULT: lightColours.accent[60]
  },
  border: {
    main: lightColours.neutral[10]
  },
  focus: lightColours.secondary[50],
  // Deprecated colors, kept for backwards compatibility
  /**
   * @deprecated use `secondary` moving forward
   */
  default: {
    100: lightColours.neutral[0],
    200: lightColours.neutral[5],
    500: lightColours.secondary[50],
    700: lightColours.secondary[100],
    800: lightColours.accent[80],
    900: lightColours.accent[100]
  },
  tabbed: {
    500: "#F8D241"
  },
  /**
   * @deprecated use `caution` or `error` moving forward
   */
  negative: {
    ...lightColours.caution,
    extraSoft: lightColours.caution[5],
    soft: lightColours.caution[10],
    medium: lightColours.caution[40],
    strong: lightColours.caution[60]
  }
};
export {
  colors
};
